/**
 * 通用组件接口文档
 */
 const config = {
  prefix: '/data',
  items: [
      // 新增自定义列
      { key: 'queryTreeOrgListById', url: '/queryTreeOrgList' },
     
  ]
}

export default req.generate(config)